(function () {
  var text = document.getElementById('tmShipText');
  var count = document.getElementById('tmShipCount');
  if (!text || !count) return;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tick() {
    var now = new Date();
    var hour = now.getHours();
    var target = new Date();

    if (hour >= 7 && hour < 12) {
      text.innerHTML = 'Genelde <b>bugün kargoda</b>';
      target.setHours(12, 0, 0, 0);
    } else if (hour >= 12) {
      text.innerHTML = 'Genelde <b>yarın kargoda</b>';
      target.setHours(24, 0, 0, 0);
    } else {
      text.innerHTML = 'Genelde <b>bugün kargoda</b>';
      target.setHours(7, 0, 0, 0);
    }

    var diff = target - now;
    if (diff < 0) diff = 0;
    var total = Math.floor(diff / 1000);
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    count.textContent = 'Kalan: ' + pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  tick();
  setInterval(tick, 1000);
})();
